export const MAX_FILE_UPLOAD_LENGTH = 1;
export const MAX_FILE_UPLOAD_SIZE = 1024 * 1024 * 10; // 10MB
export const FILE_ALLOWED_FORMAT = '.doc, .docx, .pdf, .png, .jpg, .jpeg, .hwp';
